import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'identity_shift'

const OPTIONS = [
  {
    value: 'Yes, absolutely',
    translationKey: 'pages.onboarding.v1.identityShift.options.absolutely',
  },
  {
    value: 'I can picture it',
    translationKey: 'pages.onboarding.v1.identityShift.options.pictureIt',
  },
  {
    value: 'Working towards it',
    translationKey: 'pages.onboarding.v1.identityShift.options.workingTowards',
  },
  {
    value: 'Not yet, but I want to',
    translationKey: 'pages.onboarding.v1.identityShift.options.notYet',
  },
]

export default function IdentityShiftPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question:
        'Can you see yourself as someone who lives in a clutter-free, organized space?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.identityShift.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
